import ApiClient from './ApiClient';

const api = new ApiClient();

export default api;
